import { Box, styled, TooltipProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import { FC } from 'react';
import { StoreModel } from 'src/infrastructure/rest-api/api-types';
import { LightTooltip } from '../LightToolTip/LightToolTip';

interface StoreCountToolTipProps extends Pick<TooltipProps, 'children'> {
    stores: StoreModel[];
}

export const StoreCountTooltip: FC<StoreCountToolTipProps> = ({ children, stores }) => {
    return (
        <LightTooltip
            placement="top"
            enterDelay={500}
            className={'ag-popup'}
            title={
                stores.length > 0 ? (
                    <TooltipContent>
                        {stores.map((store) => (
                            <Box key={store.storeName}>{store.storeName}</Box>
                        ))}
                    </TooltipContent>
                ) : null
            }
        >
            {children}
        </LightTooltip>
    );
};

const TooltipContent = styled(Stack)({
    gap: '0.25rem',
});
